/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.219.0-v202610292317-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export interface ColumnDefinitionInputV1 {
    /**
     * Name of the column. This will be used as the header for this column. It must be unique for this table
     */
    "columnName": string;
    /**
     * The list of rules that determine the resulting value of a column. At least one rule is required
     */
    "columnRules": Array<models.ColumnRuleInputV1>;
    /**
     * The type for the column
     */
    "columnType": ColumnTypeEnum;
    /**
     * The unit of measure for this column. This is only applicable to columns whose type                      is NUMERIC. If provided, this will enforce that data in this column must be in this unit. For                      example, if the user specifies Fahrenheit and the value comes in as Meters, the value will not be                      inserted. If not provided, values with different units will be allowed to be stored and an extra                       column will be added to the generated table for the UOM
     */
    "columnUom"?: string;
    /**
     * The optional description for this column.
     */
    "description"?: string;
    /**
     * The optional display property for this column, defaults to Name if type UUID, otherwise defaults to null.
     */
    "displayProperty"?: string;
    "isGenerated"?: boolean;
    "isHidden"?: boolean;
    "isIndexed"?: boolean;
    "isManuallyEntered"?: boolean;
    /**
     * Author-specified, item-type-specific metadata restricting items returned by this column's rules. Currently only the unit of measure is captured: Signal uses the Value Unit Of Measure key and Scalar uses the Unit Of Measure key; an absent key indicates the Any-UOM opt-out and an empty-string value indicates the dimensionless unit. Structured as an extensible map so additional item-type-specific properties can be added without a schema change.
     */
    "outputItemMetadata"?: { [key: string]: string; };
    /**
     * An author-specified item type restriction for items returned by this column's rules (e.g., Signal, Scalar, Condition). Only applicable to UUID columns. On create, absence allows any item type. On update, overrideOutputItemMetadata controls whether absence preserves or clears the existing value.
     */
    "outputItemType"?: string;
    /**
     * Controls author override state for output item metadata and defaults to false. True requires outputItemType and stores the supplied type and metadata as an override. False preserves inferred metadata while the column remains UUID, clears it when the column type changes away from UUID, or clears an existing author override when recomputation is enabled. Supplying outputItemType when creating a column creates an override even when this field is false.
     */
    "overrideOutputItemMetadata"?: boolean;
    /**
     * Whether to sort ascending if sortIndex is provided, defaults to false
     */
    "sortAscending"?: boolean;
    /**
     * The sort index for this column. If not provided, the column is not sorted.
     */
    "sortIndex"?: number;
}

export const ColumnTypeEnum = {
    UUID: 'UUID',
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    TIMESTAMPTZ: 'TIMESTAMPTZ',
    BOOLEAN: 'BOOLEAN'
} as const;

export type ColumnTypeEnum = typeof ColumnTypeEnum[keyof typeof ColumnTypeEnum];
